module.exports = __webpack_public_path__ + "static/img/index4(1)_03.226aca2.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/images/index4(1)_03.png
// module id = 3130
// module chunks = 1